import React from 'react';
import { MatchStatus } from '@gopeerproject/chuck';
import { View, Text } from 'react-native';
import { Icon } from '../..';
import { useStyleSheet, useThemeContext } from '../../../hooks';
import { createStyleSheet } from '../../../utils';
export const Badge = ({ status, selfStatus }) => {
    const { color } = useThemeContext();
    const styles = useStyleSheet(getStyles);
    const isActive = status === MatchStatus.Active;
    const isResolved = status === MatchStatus.Resolved;
    const isPending = status === MatchStatus.Pending;
    const isInactive = status === MatchStatus.Active ? selfStatus === 'inactive' : false;
    const isAbandoned = status === 'abandoned';
    const isCanceled = status === 'canceled';
    const text = isActive
        ? 'In Progress'
        : isResolved || isInactive || isAbandoned
            ? 'Resolved'
            : isPending
                ? 'Pending'
                : isCanceled
                    ? 'Canceled'
                    : '';
    return (React.createElement(View, { style: styles.container },
        React.createElement(Action, { isActive: isActive, isCanceled: isCanceled, isPending: isPending }),
        React.createElement(Text, { style: [
                styles.text,
                {
                    color: isActive
                        ? color.primary.solid
                        : isCanceled || isResolved || isInactive || isAbandoned
                            ? color.invert2.p56
                            : color.pending.solid
                },
                isResolved || isInactive || isAbandoned ? styles.strikeThrough : {}
            ] }, text)));
};
const Action = ({ isActive, isCanceled, isPending }) => {
    const { color } = useThemeContext();
    const styles = useStyleSheet(getStyles);
    return isActive ? (React.createElement(View, { style: styles.dot })) : isPending ? (React.createElement(Icon, { name: 'more-horizontal', size: 15, color: color.pending.solid })) : (React.createElement(Icon, { name: isCanceled ? 'dismiss' : 'checkmark', size: 15, color: color.invert2.p56 }));
};
const getStyles = createStyleSheet(({ color, size }) => ({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        padding: size.C,
        borderWidth: 1,
        borderColor: color.invert2.p4,
        borderRadius: 999
    },
    dot: {
        width: size.D,
        height: size.D,
        borderRadius: size.D / 2,
        backgroundColor: color.primary.solid
    },
    background: {
        backgroundColor: color.primary.ghost,
        paddingVertical: size.B,
        paddingHorizontal: size.C,
        borderRadius: 9999
    },
    text: {
        marginLeft: size.B,
        fontWeight: '600',
        color: color.primary.solid,
        fontSize: 11,
        lineHeight: 13,
        letterSpacing: -0.01
    },
    strikeThrough: {
        textDecorationLine: 'line-through',
        textDecorationStyle: 'solid'
    }
}));
//# sourceMappingURL=Badge.js.map